import React from "react"
import Row from "../components/bootstrap/row"
import SponsorBox from "../components/sponsor-box"

import ImgCoslaLogo from "./img-cosla-logo"
import ImgHealthEducationEnglandLogo from "./img-health-education-england-logo"
import ImgTechUKLogo from "./img-tech-uk-logo"
import ImgGDSLogo from "./img-gds-logo"
import ImgCabinetOfficeLogo from "./img-cabinet-office-logo"
import ImgGPALogo from "./img-gpa-logo"
import ImgIdeasUKLogo from "./img-ideas-uk-logo"
import ImgNTULogo from "./img-ntu-logo"

import cabinetOffice from "../images/logos/cabinet_office.png" // London Borough of Redbridge
import lbr from "../images/logos/lbr.png" // London Borough of Redbridge
import universityOfLeeds from "../images/logos/university-of-leeds.png" // University of Leeds
import CDDO from "../images/logos/cddo.png" // CentralDigital and Data Office
import BCS from "../images/logos/bcs.png" // British Computer Society
import CCS from "../images/logos/ccs.png" // Crown Commercial Service
import GPF from "../images/logos/government-property-function.png" // Government Property Function
import CIPD from "../images/logos/cipd.png" // CIPD
import BCC from "../images/logos/bcc.png" // Birmingham City Council
import NHSBSA from "../images/logos/nhs_bsa.png" // NHS Business Services Authority
import PPMA from "../images/logos/ppma.png" // PPMA
import theOfficeOfGovernmentProperty from "../images/logos/the_office_of_government_property.png" // The Office of Government Property
import royalFreeLondon from "../images/logos/royal-free-london.png" // Royal Free London

// import ImgDigitalBirminghamLogo from "./img-digital-birmingham-logo"

const Judges = () => {
  return (
    <div style={{
      marginBottom: `5rem`
    }}>
      <Row>
        <div className="offset-lg-1 col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff" padding="1rem"><ImgGPALogo /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={cabinetOffice} className="img-fluid" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={CCS} className="img-fluid p-3" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={CDDO} className="img-fluid" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={theOfficeOfGovernmentProperty} className="img-fluid p-3" /></SponsorBox><br />
        </div>

        <div className="offset-lg-1 col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff" padding=".5rem"><ImgGDSLogo /></SponsorBox><br />
        </div>

        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff" padding=".5rem"><ImgTechUKLogo /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff" padding="1rem"><ImgCoslaLogo /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff"><ImgHealthEducationEnglandLogo /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#fff" bgColor="#fff"><ImgIdeasUKLogo /></SponsorBox><br />
        </div>
        <div className="offset-lg-1 col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={CIPD} className="img-fluid p-2" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={NHSBSA} className="img-fluid" /></SponsorBox><br />
        </div>

        <div className="offset-lg-0 col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={BCC} className="img-fluid" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><ImgNTULogo /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={lbr} className="img-fluid" /></SponsorBox><br />
        </div>
        <div className="offset-lg-2 col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={universityOfLeeds} className="img-fluid" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={BCS} className="img-fluid p-4" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={PPMA} className="img-fluid p-4" /></SponsorBox><br />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SponsorBox fontColor="#000" bgColor="#fff"><img src={royalFreeLondon} className="img-fluid p-2" /></SponsorBox><br />
        </div>
        
      </Row>
    </div>
  )
}

export default Judges